import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCz0XlA5gGD3jiRO3NKyvSD9XF_ufwr-B8',
  authDomain: 'diagnosticos-8104a.firebaseapp.com',
  projectId: 'diagnosticos-8104a',
  storageBucket: 'diagnosticos-8104a.appspot.com',
  messagingSenderId: '458575383795',
  appId: '1:458575383795:web:3fef6696af9db2f86e3b86',
  measurementId: 'G-FPGDJ7D0KS',
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
